import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { 'Content-Type': 'application/json' } });

export const fetchArtists = (params = {}) => api.get('/artists', { params }).then(r => r.data);
export const fetchArtist = (slug) => api.get(`/artists/${slug}`).then(r => r.data);
export const fetchCities = () => api.get('/cities').then(r => r.data);
export const submitEnquiry = (payload) => api.post('/enquiries', payload).then(r => r.data);

// Native artist registration (public)
export const fetchRegistrationConfig = () => api.get('/registration-config').then(r => r.data);
export const submitApplication = (payload) => api.post('/applications', payload).then(r => r.data);
export const publicImagekitAuth = (folder = 'findyourmua/registrations') =>
  api.get('/imagekit/auth', { params: { folder } }).then(r => r.data);
export const fetchLocations = () => api.get('/locations').then(r => r.data);
export const fetchAnnouncements = () => api.get('/announcements').then(r => r.data);
